<template>
    <div class="basicData" v-wechat-title="$t('需求单详情')">
        <Title :title="$t('需求单详情')"/>
        <div class="common_title custom_title">{{ $t('客户信息') }}</div>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('呼入电话') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.incomingCall">{{ info.clientInfo.incomingCall || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('客户名称') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.clientName">{{ info.clientInfo.clientName || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('类别') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="ChangeCustomerType(info.clientInfo.category)">{{ ChangeCustomerType(info.clientInfo.category) || '--' }}</span>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('区域') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.areaName">{{ info.clientInfo.areaName || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('国家') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.country">{{ info.clientInfo.country || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('省份') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.province">{{ info.clientInfo.province || '--' }}</span>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('城市') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.prefecture">{{ info.clientInfo.prefecture || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('区县') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.county">{{ info.clientInfo.county || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('地址') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.address">{{ info.clientInfo.address || '--' }}</span>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('联系人') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.contactName">{{ info.clientInfo.contactName || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('联系人电话') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.contactPhone">{{ info.clientInfo.contactPhone || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('联系人传真') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.contactFax">{{ info.clientInfo.contactFax || '--' }}</span>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('联系人Email') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.clientInfo.contactEmail">{{ info.clientInfo.contactEmail || '--' }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="common_title detail_title">{{ $t('需求详情') }}</div>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('需求单号') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.baseInfo.requirementSn">{{ info.baseInfo.requirementSn || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('创建人') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.dealInfo.createBy">{{ info.dealInfo.createBy || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('创建时间') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.dealInfo.createTime">{{ info.dealInfo.createTime || '--' }}</span>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('结单时间') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.dealInfo.finishTime">{{ info.dealInfo.finishTime || '--' }}</span>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('撤销时间') }}:</span></div>
                    <div class="input_box">
                        <span class="text" :title="info.dealInfo.cancelTime">{{ info.dealInfo.cancelTime || '--' }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="common_title detail_title">{{ $t('服务设备信息列表') }} <span class="add_btn_title" v-permissions="210312" @click="add"></span></div>
        <div class="table_box">
            <el-table :data="info.mtList" height="300">
                <el-table-column :label="$t('设备型号')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.mtModelName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('设备编号')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.mtSn || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('CNC版本')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.mtCncVersion || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('PLC版本')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.mtPlcVersion || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('服务类型')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.serviceType || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('需求描述')" align="center">
                    <template slot-scope="scope">
                        <span :title="scope.row.description">{{ scope.row.description || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('购买日期')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.mtBuyDate || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('保修日期')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.mtWarrantyDate || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('操作')" align="center" width="120">
                    <template slot-scope="scope">
                        <div class="table_btn_box">
                            <button class="table_btn edit"
                                    :title="$t('编辑')"
                                    @click.stop="edit(scope.row)"
                            ></button>
                            <button class="table_btn delete"
                                    :title="$t('删除')"
                                    v-permissions="210312"
                                    @click.stop="deleteItem(scope.row)"
                            ></button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="edit_btn_box">
            <button type="button" class="back_btn" @click="$router.go(-1)">{{ $t('返回') }}</button>
        </div>
        <ServiceEquipmentInformation
                v-model="visible"
                :id="dialogId"
                idName="faultMtId"
                :requirementId="requirementId"
                :hasServiceTypeList="true"
                @ok="dialogOk"
        />
    </div>
</template>

<script>
    export default {
        data () {
            return {
                visible: false,
                dialogId: '',
                requirementId: this.$route.query.id || '',
                info: {
                    baseInfo: {
                        requirementSn: ''
                    },
                    clientInfo: {
                        incomingCall: ''
                    },
                    dealInfo: {
                        createBy: ''
                    },
                    distributionInfo: {
                        organizationName: ''
                    }
                }
            }
        },
        mounted () {
            this.initMounted()
        },
        methods: {
            initMounted () {
                this.read()
            },
            add () {
                this.dialogId = ''
                this.requirementId = this.$route.query.id
                this.visible = true
            },
            edit (item) {
                this.dialogId = item.id
                this.visible = true
            },
            deleteItem (item) {
                this.$confirm(this.$t('删除后无法恢复，确认删除该条记录'), this.$t('提示'), {
                    confirmButtonText: this.$t('确定'),
                    confirmButtonClass: 'save__btn',
                    cancelButtonText: this.$t('取消'),
                    cancelButtonClass: 'back__btn',
                    type: 'warning',
                    center: true,
                    showClose: false
                }).then(() => {
                    this.$store.dispatch('a:manageNetList/delete', {faultMtId: item.id}).then(
                        () => {
                            this.$message.success(this.$t('成功删除'))
                            this.read()
                        },
                        rej => {
                            this.$message.error(rej.errorInfo);
                        }
                    )
                }).catch(() => {

                });
            },
            dialogOk (data) {
                this.$store.dispatch(data.id ? 'a:manageNetList/update' : 'a:manageNetList/create', data).then(
                    () => {
                        this.requirementId = this.dialogId = ''
                        this.$message.success(this.$t('保存成功'));
                        this.read()
                        this.visible = false
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            read () {
                this.$store.dispatch('a:manageNetList/readDetail', {requirementId: this.$route.query.id}).then(
                    res => {
                        this.info = res
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            }
        }
    }
</script>

<style lang="scss" scoped>
.add_btn_title {
    float: right;
    margin-right: -26px;
    margin-top: 5px;
}
</style>
